export const cityTransportUrl = (citySlug: string) =>
  `/transporte-de-veiculos-${citySlug}`;
